/** Yuvarlak avatar kadrajı (API crop_meta ile uyumlu). */

export const DEFAULT_AVATAR_CROP = { x: 0, y: 0, zoom: 1 };

export function normalizeCropMeta(raw) {
  if (raw == null || typeof raw !== 'object') {
    return { ...DEFAULT_AVATAR_CROP };
  }
  const x = Math.max(-1, Math.min(1, Number(raw.x) || 0));
  const y = Math.max(-1, Math.min(1, Number(raw.y) || 0));
  const zoom = Math.max(1, Math.min(2.5, Number(raw.zoom) || 1));
  return { x, y, zoom };
}

export function isDefaultCrop(c) {
  const n = normalizeCropMeta(c);
  return Math.abs(n.x) < 1e-6 && Math.abs(n.y) < 1e-6 && Math.abs(n.zoom - 1) < 1e-6;
}

/** API/body: varsayılan ise null (alan yazılmaz / silinir). */
export function cropMetaForApi(c) {
  return isDefaultCrop(c) ? null : normalizeCropMeta(c);
}
